export default "__VITE_ASSET__CF$RjG1Y__"